import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  LoginInfo,
  CreateLoginInfoRequest,
  CreateLoginInfoResponse,
  UpdateLoginInfoRequest,
  UpdateLoginInfoResponse,
  DeleteLoginInfoResponse,
  GetLoginInfosRequest,
  GetLoginInfosResponse,
} from './login-info.type';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginInfoService {
  private apiUrl = environment.apiBaseURL + '/login-info';

  constructor(private http: HttpClient) { }

  getLoginInfos(request: GetLoginInfosRequest = {}): Observable<GetLoginInfosResponse> {
    let params = new HttpParams();

    if (request.pageIndex !== undefined) {
      params = params.set('pageIndex', request.pageIndex.toString());
    }
    if (request.pageSize !== undefined) {
      params = params.set('pageSize', request.pageSize.toString());
    }
    if (request.search) {
      params = params.set('email', request.search);
    }

    return this.http.get<GetLoginInfosResponse>(this.apiUrl, { params });
  }

  getLoginInfo(email: string): Observable<LoginInfo> {
    return this.http.get<LoginInfo>(`${this.apiUrl}/${encodeURIComponent(email)}`);
  }

  createLoginInfo(request: CreateLoginInfoRequest): Observable<CreateLoginInfoResponse> {
    return this.http.post<CreateLoginInfoResponse>(this.apiUrl, request);
  }

  updateLoginInfo(email: string, request: UpdateLoginInfoRequest): Observable<UpdateLoginInfoResponse> {
    return this.http.put<UpdateLoginInfoResponse>(`${this.apiUrl}/${encodeURIComponent(email)}`, request);
  }

  deleteLoginInfo(email: string): Observable<DeleteLoginInfoResponse> {
    return this.http.delete<DeleteLoginInfoResponse>(`${this.apiUrl}/${encodeURIComponent(email)}`);
  }

}
